var map = {
	"./alibaba-cloud.png": "c9d3",
	"./amadeus.png": "bedb",
	"./apidays-2023.png": "a474",
	"./apisfirst.png": "7a65",
	"./atlassian-community.png": "1cc0",
	"./auth0.png": "e27d",
	"./aws.png": "4cab",
	"./benovelty.png": "7c2c",
	"./confluent.png": "bf0d",
	"./dala.png": "ee41",
	"./daops.png": "3c98",
	"./f5.png": "dc6e",
	"./fabrix.png": "a239",
	"./fabrixapi.png": "4b16",
	"./forgerock.png": "6d27",
	"./hkcs.png": "5316",
	"./hkstp-2023.png": "3c13",
	"./hkstp-saa.png": "17a8",
	"./hkstpsaa.png": "0e65",
	"./ibm.png": "c162",
	"./ifta.png": "d4aa",
	"./isoc.png": "8c47",
	"./moongate.png": "dbf9",
	"./mulesoft.png": "4060",
	"./new-relic.png": "851c",
	"./nginx-f5.png": "546f",
	"./nginx.png": "184e",
	"./on-us.png": "60b6",
	"./openapihub.png": "f572",
	"./softwareag.png": "2ce1",
	"./suse.png": "3017",
	"./wia.png": "de92",
	"./wso2.png": "b2b4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ba5";